import { useTranslations } from '@vocab/react';
import { Dialog, Text, useToast } from 'braid-design-system';
import type React from 'react';

import translations from '../.vocab';

import { DeleteDraftJobDialogContent } from './DeleteDraftJobDialogContent';

interface DeleteDraftJobDialogProps {
  draftId: string;
  open: boolean;
  onClose(): void;
}

export const DeleteDraftJobDialog: React.FC<
  React.PropsWithChildren<DeleteDraftJobDialogProps>
> = ({ open, onClose, draftId }) => {
  const { t } = useTranslations(translations);
  const showToast = useToast();
  const onSuccess = () => {
    showToast({
      tone: 'positive',
      message: t('The draft job ad has been deleted successfully'),
    });
    onClose();
  };

  return (
    <Dialog
      id={`delete-draft-job-${draftId}`}
      title={t('Delete your draft ad')}
      description={<Text>{t('Are you sure')}</Text>}
      open={open}
      onClose={onClose}
    >
      <DeleteDraftJobDialogContent
        onClose={onClose}
        draftId={draftId}
        onSuccess={onSuccess}
      />
    </Dialog>
  );
};
